<template>
  <vn-bar
    :model="barChart.data"
    textField="label"
    valueField="value"
    :staggerLabels="barChart.staggerLabels"
    x-format=",.1f"
    y-format=",.2f"
  >
  </vn-bar>
</template>

<script>
export default {
  data() {
    var barChartData = [
      {
        key: "Cumulative Return",
        values: [
          { label: "Johor", value: 1, color: "#E57373" },
          { label: "Kedah", value: 2, color: "#F06292" },
          { label: "Kelantan", value: 2, color: "#BA68C8" },
          { label: "Negeri Sembilan", value: 4, color: "#9575CD" },
          { label: "Pahang", value: 5, color: "#7986CB" },
          { label: "Perak", value: 6, color: "#64B5F6" },
          { label: "Pulau Pinang", value: 7, color: "#4DB6AC" },
          { label: "Sarawak", value: 1, color: "#66BB6A" },
          { label: "Selangor", value: 2, color: "#FFB74D" },
          { label: "Terengganu", value: 3, color: "#FF8A65" },
        ],
      },
    ];
    return {
      barChart: {
        data: barChartData,
        staggerLabels: true,
      },
    };
  },
};
</script>
